import assign from 'object-assign';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {setErrors} from '../../actions/ui';


function getValues(form) {
  let data = {};
  for (let i in form) {
    if (form.hasOwnProperty(i)) {
      data[i] = form[i].value;
    }
  }
  return data;
}


function serializeContact(contact, data = {}) {
  return assign(contact, data);
}


function serializeAddress(address, data = {}) {
  return assign(address, data);
}


@connect(
  state => {
    let {me, address, spouse, familyMembers} = state; 
    me = getValues(me);
    let maritalStatus = state.maritalStatuses.byId[me.Marital_Status_ID] || {
      Marital_Status: "Single",
      Marital_Status_ID: 1
    };

    return {
      data: {
        me: serializeContact(me),
        spouse: maritalStatus.Marital_Status === 'Married' ?
          serializeContact(getValues(spouse), {Marital_Status_ID: me.Marital_Status_ID}) : null,
        address: state.ui.showAddressForm ? serializeAddress(getValues(address)) : null,
        family_members: familyMembers.ids.map(i => serializeContact(getValues(familyMembers.byId[i]))),
        congregation_id: state.congregations.selected
      }
    };
  },
  dispatch => ({
    setErrors(errors) {
      dispatch(setErrors(errors));
    }
  })
)
export default class SubmitRoute extends PureComponent {
  componentDidMount() {
    let {data} = this.props;
    fetch('https://planyourvisit-user.gateway.apps.blackpulp.com/api/v1/households/create_entire_family', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.ok) {
        if (this.props.onSuccess) {
          response.json().then(({token}) => {
            this.props.onSuccess(token);
          });
        }
        else {
          this.props.history.push('/thanks');
        }
      }
      else {
        this.props.history.push('/errors');
        response.json().then(responseData => {
          console.log('error data', responseData);
          if (responseData.errors) {
            this.props.setErrors(responseData.errors);
          }
        });
      }
    });
  }
  render() {
    return (
      <div className="submit-route">
        Saving your info...
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/submit-route/index.js